import React, {Component} from 'react'
import {connect} from 'react-redux'
import {api} from "../../../../../api";
import PromotionsPeriodsComponent from '../../parts/periods'
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import MenuItem from 'material-ui/MenuItem';
import {withRouter} from 'react-router-dom';
import {loadCampaigns} from "../../../../../api/settings/campaigns";
import AppErrorDialogComponent from '../errorDialog';
import {HotKeys} from 'react-hotkeys';
import Toggle from 'material-ui/Toggle';


const sidePositions = [
	{'slug': 'side_featured_post'},
	{'slug': 'side_textad'},
	{'slug': 'side_recent_articles'},
	{'slug': 'side_term_posts'},
	{'slug': 'side_job_posts'},
	{'slug': 'side_whitepapers'},
	{'slug': 'side_rectangle'},
	{'slug': 'side_lead_collector'},
	{'slug': 'side_free_product'},
];

const ctaPositions = [
	{'slug': 'side_editorial_anchorcta'},
	{'slug': 'side_anchorcta'},
];

class AppPromotionsFormComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			sideAdPositions: [
				{
					value: 'r1',
					title: 'Redactioneel 1',
					show : sidePositions,
				},
				// {
				// 	value: 'r2',
				// 	title: 'Redactioneel 2',
				// 	show : sidePositions,
				// },
				// {
				// 	value: 'r3',
				// 	title: 'Redactioneel 3',
				// 	show : sidePositions,
				// },
				// {
				// 	value: 'r4',
				// 	title: 'Redactioneel 4',
				// 	show : sidePositions,
				// },
				// {
				// 	value: 'c1',
				// 	title: 'Commercieel 1',
				// 	show : sidePositions,
				// },
				// {
				// 	value: 'c2',
				// 	title: 'Commercieel 2',
				// 	show : sidePositions,
				// },
				// {
				// 	value: 'c3',
				// 	title: 'Commercieel 3',
				// 	show : sidePositions,
				// },
				// {
				// 	value: 'c4',
				// 	title: 'Commercieel 4',
				// 	show : sidePositions,
				// },
				{
					value: 'cta1',
					title: 'Anchor CTA 1',
					show : ctaPositions,
				},
				// {
				// 	value: 'cta2',
				// 	title: 'Anchor CTA 2',
				// 	show : ctaPositions,
				// },
				// {
				// 	value: 'cta3',
				// 	title: 'Anchor CTA 3',
				// 	show : ctaPositions,
				// },
			],
			showErrorDialog: false,
			errors         : [],
		};

		this.savePromotion = this.savePromotion.bind(this);
		this.handleState = this.handleState.bind(this);
		this.handleSelectChange = this.handleSelectChange.bind(this);
		this.addPeriod = this.addPeriod.bind(this);
		this.addVariant = this.addVariant.bind(this);
		this.triggerSaveButton = this.triggerSaveButton.bind(this);
	}

	componentDidMount() {
		loadCampaigns();
	}

	handleSelectChange(name, event, index, value) {
		api.promotions.handleState(name, value);

		if ('position' === name) {
			if (value.indexOf('side_') > -1) {
				this.setState({
					...this.state,
					showSideAdOptions: true
				});
			} else {
				this.setState({
					...this.state,
					showSideAdOptions: false
				});
			}
		}
	}

	handleState(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		api.promotions.handleState(name, value);
	}

	addPeriod(event) {
		api.promotions.addPeriod();

		event.preventDefault();
	}

	addVariant(periodKey) {
		this.setState((prevState) => {
			const {periods} = prevState;
			periods[periodKey].variants.push([...periods[periodKey].variants, {...api.promotions.defaultPromotion.periods[0].variants[0]}]);
			return {periods};
		});
	}

	savePromotion(event) {
		this.props.savePromotion(event).then((internalId) => {
			api.snackbar.showMessage('De promotie is opgeslagen.');
			this.props.history.push('/app/promotions/promotion/' + internalId);
		}).catch((errors) => {
			this.setState({
				errors         : errors,
				showErrorDialog: true,
			})
		});

		event.preventDefault();
	}

	checkRequiredFields() {

	}

	selectItems(items, filter = false) {
		if (true === filter) {
			items = items.filter((item, key) => {
				const s = item.show.find((show, key) => {
					return this.props.promotion.position === show.slug;
				});

				return undefined !== s;
			});
		}


		return items.map((item, key) => {
			return (
				<MenuItem
					key={key}
					insetChildren={true}
					checked={this.props.promotion.position === item.value}
					value={item.value}
					primaryText={item.title}
				/>
			);
		});
	}

	triggerSaveButton() {
		document.getElementById('savePromotionButton').click();
	}

	toggleABTest( isChecked ) {
		api.promotions.handleState( 'autoAbTest', isChecked );
	}

	render() {

		const handlers = {
			'savePromotion': this.triggerSaveButton
		};

		const key = Object.keys(api.promotions.types).find((key) => {
			return api.promotions.types[key].value === this.props.promotion.position;
		});

		let typeComponent = '';
		let promotionPeriodsComponent = '';
		let sideComponent = '';

		if (undefined !== key) {
			const GeneralComponent = api.promotions.types[key].components.general;
			const VariantsComponent = api.promotions.types[key].components.variant;
			const SideComponent = api.promotions.types[key].components.side;
			const imageSizes = api.promotions.types[key].images;


			if (false !== GeneralComponent) {
				typeComponent = <GeneralComponent imageSizes={imageSizes} />;
			}

			if (false !== VariantsComponent) {
				promotionPeriodsComponent = <PromotionsPeriodsComponent addVariant={this.addVariant} />;
			}

			if (false !== SideComponent) {
				sideComponent = <SideComponent />
			}
		}

		let upperClassNames = [
			'medium-4',
			'cell',
		];

		if (this.props.promotion.position.indexOf('side_') > -1) {
			upperClassNames = upperClassNames.filter((e) => {
				return e !== 'medium-4' && e !== 'medium-3';
			});

			upperClassNames.push('medium-3');
		} else {
			upperClassNames = upperClassNames.filter((e) => {
				return e !== 'medium-4' && e !== 'medium-3';
			});

			upperClassNames.push('medium-4');
		}

		return (
			<HotKeys handlers={handlers}>
				<form onSubmit={this.savePromotion}>
					<AppErrorDialogComponent show={this.state.showErrorDialog} errors={this.state.errors} />
					<div className="grid-x grid-padding-x grid-margin-y">
						<div className={upperClassNames.join(' ')}>
							<label>
								Titel
								<TextField fullWidth={true} hintText="Vul de naam van de promotie in" name="name" value={this.props.promotion.name} onChange={this.handleState} />
							</label>
						</div>

						<div className={upperClassNames.join(' ')}>
							<label>
								Campagne
								<SelectField
									hintText="Selecteer een campagne"
									value={this.props.promotion.campaign}
									onChange={this.handleSelectChange.bind(null, 'campaign')}
									fullWidth={true}
								>
									{
										this.props.campaigns.campaigns.map((campaign, key) => {

											if (true === campaign.archived) return null;

											return (
												<MenuItem
													key={key}
													insetChildren={true}
													checked={this.props.promotion.campaign === campaign.value}
													value={campaign.key} primaryText={campaign.title}

												/>
											)
										})
									}
								</SelectField>
							</label>
							<small><a href="#" onClick={api.campaigns.OpenCreateNewCampaignModal}>Nieuwe campagne</a>
							</small>
						</div>

						<div className={upperClassNames.join(' ')}>
							<label>
								Positie

								<SelectField
									hintText="Selecteer een positie"
									value={this.props.promotion.position}
									onChange={this.handleSelectChange.bind(null, 'position')}
									selectionRenderer={this.selectionRenderer}
									name="position"
									fullWidth={true}
								>

									{this.selectItems(api.promotions.types)}
								</SelectField>
							</label>
						</div>

						{this.props.promotion.position.indexOf('side_') > -1 &&
						<div className={upperClassNames.join(' ')}>
							<label>
								Kantlijn positie

								<SelectField
									hintText="Selecteer een kantlijn positie"
									value={this.props.promotion.sideAdPosition}
									onChange={this.handleSelectChange.bind(null, 'sideAdPosition')}
									name="sideAdPosition"
									fullWidth={true}
								>

									{this.selectItems(this.state.sideAdPositions, true)}
								</SelectField>
							</label>
						</div>

						}
					</div>

					{undefined !== key && api.promotions.types[key].hasUrl === true &&
					<div className="grid-x grid-padding-x grid-margin-y">
						<div className="medium-12 cell">
							<label>
								URL
								<TextField fullWidth={true} hintText="Voer de url in waar de bezoeker heen moet gaan nadat deze op de promotie heeft geklikt" name="url" value={this.props.promotion.url} onChange={this.handleState} />
							</label>
						</div>
					</div>
					}

					{typeComponent}

					{sideComponent}

					{promotionPeriodsComponent}

					<div className="grid-x grid-padding-x grid-padding-y">
						<div className="cell">
							<Toggle
								label={`Automatische A/B test ${(false === this.props.promotion.autoAbTest || undefined === this.props.promotion.autoAbTest ? `uitgeschakeld` : 'ingeschakeld')}`}
								labelPosition={'right'}
								onToggle={(event, isInputChecked) => this.toggleABTest(isInputChecked)}
								toggled={this.props.promotion.autoAbTest}
							/>
						</div>
						<div className="cell">
							<button className="button primary" id={'savePromotionButton'} type="submit">{this.props.savePromotionLabel}</button>
						</div>
					</div>
				</form>
			</HotKeys>
		)

	}
}

const mapStateToProps = (state) => {
	return {
		promotion: state.promotion,
		campaigns: state.campaigns,
	}
};

export default withRouter(connect(mapStateToProps, {
	loadCampaigns
})(AppPromotionsFormComponent));



// WEBPACK FOOTER //
// ./src/application/components/promotions/components/parts/form.js